import { useRemoteClientPost } from '../../../../../configs/http-client'
import { CatchMessageError } from '../../../../../remote/catch-message-error'
import { useLocalStorage } from '../../../../../remote/local-storage'
import { useToast } from '../../../../hooks'

type paymentType = 'CARTAO_CREDITO' | 'CARTAO_DEBITO' | 'DINHEIRO' | 'PIX'

type transactionType = 'ENTRADA' | 'SAIDA'

type statusHistory = 'PENDENTE' | 'RECEBIDO' | 'CONFIRMADO'

interface Transaction {
  formaPagamento: paymentType
  valor: number
  descricao: string
  idCliente?: number
  nomeCliente?: string
  statusHistorico: statusHistory
  idResponsavel: number
  nomeResponsavel: string
}

export const CashRegisterTransaction = (callbackReload: () => void) => {
  const { getUnitId } = useLocalStorage()
  const { httpClientPost } = useRemoteClientPost('finance')
  const { showToast } = useToast()

  const transaction = async (data: Transaction, tipo: transactionType) => {
    httpClientPost('/caixa/transacionar', { ...data, tipo, idUnidade: getUnitId() })
      .then(() => {
        callbackReload()
        showToast('Operação realizada com sucesso', 'success')
      })
      .catch(CatchMessageError)
  }

  const transactionEncrease = (data: Transaction) => {
    return transaction(data, 'ENTRADA')
  }

  const transactionDecrease = (data: Transaction) => {
    return transaction(data, 'SAIDA')
  }

  return {
    transactionDecrease,
    transactionEncrease
  }
}
